import {Route, Switch, useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {Overview} from "../view/discount/Overview";
import {Edit} from "../view/discount/Edit";
import {UpdateDiscount} from "../view/discount/UpdateDiscount";
import {get, getResponseBody, post} from "../js/api";
import {addDirtyListener, markDirty, showError, showMessage} from "../js/main";
import {createEmptyDiscount} from "../view/discount/discountUtil";

export const Discounts = () => {

    const history = useHistory();
    const [discounts, setDiscounts] = useState(null);
    const [keys, setKeys] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const init = () => {
        get("/discounts").then(setDiscounts);
        get("/keys").then(setKeys);
    };

    useEffect(() => {
        init();
        addDirtyListener(init);
    }, []);

    const handleApiError = (error) => {
        const body = getResponseBody(error);
        if (typeof body === "string" && body.trim() !== "") {
            showError(body);
            return;
        }

        showError("Rabatt konnte nicht gespeichert werden.");
    };

    const createDiscount = (discountInfo) => {
        return post("/discounts", discountInfo, false)
            .then(() => {
                markDirty();
                showMessage("Rabatt wurde erstellt.");
                history.push("/rabatte");
            })
            .catch(handleApiError);
    };

    return (
        <Switch>
            <Route exact path="/rabatte">
                <Overview discounts={discounts}/>
            </Route>
            <Route exact path="/rabatte/edit/:discountId">
                <UpdateDiscount discounts={discounts} keys={keys} handleApiError={handleApiError}/>
            </Route>
            <Route exact path="/rabatte/neu">
                <Edit initialDiscountInfo={createEmptyDiscount()}
                      keys={keys}
                      saveAction={createDiscount}
                      submitting={submitting}
                      setSubmitting={setSubmitting}/>
            </Route>
        </Switch>
    );
};
